import React, { useEffect, useLayoutEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';

import { Languages, SUPPORTED_LANGUAGES } from '@/shared/constants';
import { ROUTES } from '@/shared/routes';
import { isStandalone } from '@/shared/services/pwa-install';

const LanguageGuard: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { lang } = useParams();
  const location = useLocation();
  const { i18n } = useTranslation();
  const supportedLngs = useMemo(
    () => i18n.options.supportedLngs || SUPPORTED_LANGUAGES,
    [i18n.options.supportedLngs]
  );

  useLayoutEffect(() => {
    if (lang && !supportedLngs.includes(lang)) {
      // Неподдерживаемый язык → тот же путь на ru (корень сегмента — лендинг).
      const newPath =
        location.pathname.replace(new RegExp(`/${lang}`), `/${Languages.ru}`) +
        location.search;

      window.location.href = newPath;
    } else if (location.pathname === '/') {
      // Корень без языка (в т.ч. start_url установленной PWA): standalone → сразу
      // приложение, браузер → лендинг. Язык — сохранённый пользовательский, иначе ru.
      const target = supportedLngs.includes(i18n.language)
        ? i18n.language
        : Languages.ru;

      window.location.href = isStandalone()
        ? `/${target}/${ROUTES.home}`
        : `/${target}`;
    } else if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [location, lang, i18n, supportedLngs]);

  // Настройки языка документа для SEO
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return children;
};

export { LanguageGuard };
